import R from 'ramda';

export const sortList = {
	data() {
		return {
			sortable_state: {
				path: [],
				desc: true,
			}
		}
	},
	methods: {
		sortList(param){
			this.setSortable(param)
			this.updateSortList()
		},

		setSortable(param) {
			let new_path = typeof param === 'string' ? [param] : param
			this.sortable_state = {
				path: typeof param === 'string' ? [param] : param,
				desc: !R.equals(this.sortable_state.path, new_path) || !this.sortable_state.desc
			}
		},

		updateSortList() {
			let order = this.sortable_state.desc ? "descend" : "ascend"
			this.list = R.sortWith([
				R[order](this.getPropToSort)
			],this.list || [])
		},

		getPropToSort(obj) {
			let value = R.path(this.sortable_state.path)(obj)
			value = R.contains(value, [null, undefined]) ? "" : value
			return typeof value === 'string' ? this.toLowerCase(value) : value
		},

		toLowerCase(string) {
			return string.toLowerCase()
				.normalize("NFD")
				.replace(/[\u0300-\u036f]/g, "")
		}


	}
};
